module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/landing-page-headshot/landing-page-headshot@3x.png"